import { gql } from "@apollo/client";
import {
  LayoutNodeFragment,
  LayoutNodeLinkNoNestingFragment,
  LayoutNodeFilterNoNestingFragment,
  PaginatedListMetaNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { LayoutNode as LayoutNodeEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import LayoutNodeModel from "../../data/model/LayoutNode";
import { listOptions, listVariables } from "../constants";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { pageQuery } from "../page-query";

const layoutNodesQuery = gql`
  ${LayoutNodeLinkNoNestingFragment}
  ${LayoutNodeFilterNoNestingFragment}
  ${LayoutNodeFragment}
  ${PaginatedListMetaNoNestingFragment}
query GetLayoutNodes(${listVariables}) {
    layoutNodes(${listOptions}) {
        items {
           ...LayoutNode
        }
        meta {
          ...PaginatedListMetaNoNesting
        }
    }
}
`;

export const layoutNodeDefinition = new EntityResourceDefinition<
  LayoutNodeEntity,
  LayoutNodeModel
>({
  entity: "layout_nodes",
  query: layoutNodesQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.label = fetchedEntity.label || null;
    newEntity.color = fetchedEntity.color || null;
    newEntity.layout.id = fetchedEntity.layoutId || null;
    newEntity.showImage = fetchedEntity.showImage || false;
    newEntity.type = fetchedEntity.type || null;
    newEntity.position = fetchedEntity.position;
    newEntity.action = fetchedEntity.action || null;
    newEntity.productId = fetchedEntity.productId || null;
    newEntity.link = fetchedEntity.link || null;
    newEntity.filter = fetchedEntity.filter || null;
    newEntity.imageUrl = fetchedEntity.imageUrl || null;
    newEntity.labelColor = fetchedEntity.labelColor || null;
  },
  fetchEntities: (options) => {
    return pageQuery(client, "layoutNodes", layoutNodesQuery, options);
  },
});
